<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>老师管理</Breadcrumb-item>
        <Breadcrumb-item>被推荐人管理</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search search-compact" @keyup.enter="search">
      <Form :label-width="78" :show-message="false">
        <Row :gutter="12">
          <Col :span="6">
            <FormItem label="被推荐人">
              <Input
                placeholder="ID/姓名，支持模糊搜索"
                v-model="queryParam.recommendedKeyword"
                clearable
              ></Input>
            </FormItem>
          </Col>
          <Col :span="6">
            <FormItem label="推荐官">
              <Input
                placeholder="ID/姓名，支持模糊搜索"
                v-model="queryParam.referrerKeyword"
                clearable
              ></Input>
            </FormItem>
          </Col>
          <Col :span="6">
            <FormItem label="推荐官FM">
              <Select
                v-model.number="queryParam.fmId"
                placeholder="全部"
                clearable
                filterable
                transfer
                @on-change="search"
              >
                <Option
                  v-for="item in fmList"
                  :value="item.id"
                  :key="item.id"
                >{{ item.nickname }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :span="6">
            <FormItem label="开课月份">
              <Date-picker
                type="month"
                placeholder="选择月份"
                v-model="queryParam.openClassMonth"
                format="yyyy-MM"
                @on-change="openClassMonthChange"
                clearable
              ></Date-picker>
            </FormItem>
          </Col>
          <Col :span="6">
            <FormItem label="上课年月">
              <Date-picker
                type="month"
                placeholder="选择月份"
                v-model="queryParam.month"
                format="yyyy-MM"
                @on-change="monthChange"
                clearable
              ></Date-picker>
            </FormItem>
          </Col>
          <Col :span="6">
            <FormItem label="发放状态">
              <Select v-model="queryParam.grantStatus" placeholder="全部" clearable @on-change="search">
                <Option :value="0">待审核</Option>
                <Option :value="1">已发放</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :span="6">
            <FormItem label="是否奖励期">
              <Select v-model.number="queryParam.isInRewardPeriod" placeholder="全部" clearable @on-change="search">
                <Option :value="1">是</Option>
                <Option :value="0">否</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :span="6">
            <FormItem label="HR">
              <Select v-model="queryParam.hr" placeholder="全部" clearable transfer @on-change="search">
                <Option v-for="item in $constant.hrList" :value="item.code" :key="item.code">{{ item.text }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </div>

    <div class="btn-container">
      <Row>
        <Button type="primary" :loading="searchLoading" @click="search" icon="search">搜索</Button>
        <Button type="primary" @click="handleExport" icon="ios-download-outline">导出</Button>
        <Button type="primary" @click="handleBatchGrant" icon="checkmark">批量发放</Button>
      </Row>
    </div>

    <Table
      ref="table"
      :columns="title"
      :data="tableData"
      :loading="tableLoading"
      @on-selection-change="selectionChange"
      border
      stripe
      size="large"
    ></Table>
    <div class="fee-summary">
      课时汇总：{{ summaryLesson }}　金额汇总：${{ summaryAmount }}
    </div>
    <Page
      style="margin-top: 10px"
      :total="totalCount"
      show-elevator
      :current="pageIndex"
      :pageSize="pageSize"
      @on-change="changePageIndex"
      show-total
    ></Page>
  </div>
</template>

<script>
export default {
  data () {
    return {
      searchLoading: false,
      tableLoading: false,
      tableData: [],
      totalCount: 0,
      pageIndex: 1,
      pageSize: 10,
      selectedRows: [],
      summaryLesson: 0,
      summaryAmount: '0.00',
      fmList: [],
      queryParam: {
        recommendedKeyword: '',
        referrerKeyword: '',
        fmId: null,
        openClassMonth: '',
        month: '',
        grantStatus: null,
        isInRewardPeriod: null,
        hr: ''
      },
      title: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '被推荐人',
          width: 180,
          ellipsis: true,
          render: (h, params) => {
            return this.renderIdName(h, params.row.recommendedId, params.row.recommendedName)
          }
        },
        {
          title: '开课日期',
          width: 120,
          align: 'center',
          key: 'openClassDate'
        },
        {
          title: '是否奖励期',
          width: 96,
          align: 'center',
          render: (h, params) => {
            return h('span', {
              style: { color: params.row.isInRewardPeriod ? '#19be6b' : '#999' }
            }, params.row.isInRewardPeriod ? '是' : '否')
          }
        },
        {
          title: '推荐官',
          width: 180,
          ellipsis: true,
          render: (h, params) => {
            return this.renderIdName(h, params.row.referrerId, params.row.referrerName)
          }
        },
        {
          title: '推荐官FM',
          width: 140,
          ellipsis: true,
          render: (h, params) => {
            return this.renderIdName(h, params.row.fmId, params.row.fmName)
          }
        },
        {
          title: 'HR',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let options = this.$constant.hrList.slice()
            if (row.hr && !options.some(item => item.code === row.hr)) {
              options = [{ code: row.hr, text: row.hr }].concat(options)
            }
            return h('Select', {
              props: {
                value: row.hr,
                transfer: true,
                clearable: true
              },
              on: {
                'on-change': value => {
                  let newValue = value || ''
                  if (newValue !== (row.hr || '')) {
                    row.hr = newValue
                    this.updateHr(row, newValue)
                  }
                }
              }
            }, options.map(item => {
              return h('Option', { props: { value: item.code }, key: item.code }, item.text)
            }))
          }
        },
        {
          title: '完成课时',
          width: 90,
          align: 'center',
          key: 'lessonCount'
        },
        {
          title: '奖励截止年月',
          width: 120,
          align: 'center',
          key: 'rewardEndMonth'
        },
        {
          title: '奖励金额($)',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('span', {
              style: { color: params.row.isInRewardPeriod ? '#19be6b' : '#999' }
            }, params.row.feeAmount || 0)
          }
        },
        {
          title: '发放状态',
          width: 112,
          align: 'center',
          render: (h, params) => {
            let status = params.row.grantStatus
            return h('Select', {
              props: {
                value: status,
                size: 'small',
                transfer: true
              },
              class: 'grant-status-select',
              on: {
                'on-change': value => this.updateGrantStatus(params.row, value)
              }
            }, [
              h('Option', { props: { value: 0 } }, '待审核'),
              h('Option', { props: { value: 1 } }, '已发放')
            ])
          }
        },
        {
          title: '发放时间',
          width: 160,
          align: 'center',
          key: 'grantTime'
        }
      ]
    }
  },
  mounted () {
    this.loadFmList()
    this.loadList()
  },
  methods: {
    loadFmList () {
      this.$http.post('/adminUser/listByCondition', { adminGroupId: 7, status: 1 }).then(res => {
        this.fmList = res.data || []
      })
    },
    search () {
      this.pageIndex = 1
      this.loadList()
    },
    onLoading (loading) {
      this.searchLoading = loading
    },
    openClassMonthChange (value) {
      this.queryParam.openClassMonth = value
    },
    monthChange (value) {
      this.queryParam.month = value
    },
    formatIdName (id, name) {
      let nameText = name == null ? '' : String(name).trim()
      if (!nameText) {
        nameText = '-'
      }
      if (id == null || String(id).trim() === '') {
        return nameText
      }
      return id + '-' + nameText
    },
    renderIdName (h, id, name) {
      let text = this.formatIdName(id, name)
      return h('Poptip', {
        class: 'fee-name-poptip',
        props: {
          trigger: 'click',
          transfer: true,
          placement: 'bottom-start',
          wordWrap: true
        }
      }, [
        h('span', {
          class: 'fee-name-cell'
        }, text),
        h('div', {
          slot: 'content',
          style: {
            maxWidth: '320px',
            whiteSpace: 'normal',
            wordBreak: 'break-all',
            lineHeight: '22px'
          }
        }, text)
      ])
    },
    toYearMonth (value) {
      if (value == null || value === '') {
        return ''
      }
      if (value instanceof Date && !isNaN(value.getTime())) {
        let y = value.getFullYear()
        let m = value.getMonth() + 1
        return y + '-' + (m < 10 ? '0' + m : '' + m)
      }
      let text = String(value).trim()
      if (!text) {
        return ''
      }
      // DatePicker / axios 可能给出 ISO 或 yyyy-MM-dd，统一截成 yyyy-MM
      if (/^\d{4}-\d{2}/.test(text)) {
        return text.slice(0, 7)
      }
      return text
    },
    buildQueryParam () {
      let params = { ...this.queryParam }
      if (params.hr === '') {
        delete params.hr
      }
      if (params.fmId === null || params.fmId === undefined || params.fmId === '') {
        delete params.fmId
      }
      let openClassMonth = this.toYearMonth(params.openClassMonth)
      if (openClassMonth) {
        params.openClassMonth = openClassMonth
      } else {
        delete params.openClassMonth
      }
      let month = this.toYearMonth(params.month)
      if (month) {
        params.month = month
      } else {
        delete params.month
      }
      return params
    },
    updateHr (row, newValue) {
      this.$http.post('/tch/update-direct', { tchForm: { tchId: row.recommendedId, hr: newValue } }).then(res => {
        if (res.status === 'ok') {
          this.$Message.success('更新成功')
        } else {
          this.$Message.error(res.msg)
        }
      })
    },
    loadList () {
      let self = this
      this.tableLoading = true
      let params = this.buildQueryParam()
      params.pageIndex = this.pageIndex
      params.pageSize = this.pageSize

      this.$http.post('/referrer/fee/list', params).then(res => {
        if (res && res.data) {
          self.tableData = res.data.data || []
          self.totalCount = res.data.totalCount || 0
          self.applySummary(res.data.result)
        } else {
          self.tableData = []
          self.totalCount = 0
          self.applySummary('')
        }
      }).finally(() => {
        self.tableLoading = false
      })
    },
    applySummary (result) {
      let parts = String(result || '').split(',')
      this.summaryLesson = parts[0] || 0
      this.summaryAmount = parts[1] || '0.00'
    },
    changePageIndex (page) {
      this.pageIndex = page
      this.loadList()
    },
    selectionChange (selection) {
      this.selectedRows = selection || []
    },
    buildFeePayload (row, grantStatus) {
      let payload = {
        id: row.id,
        recommendedId: row.recommendedId,
        month: row.month,
        referrerId: row.referrerId,
        lessonCount: row.lessonCount,
        feeAmount: row.feeAmount,
        openClassDate: row.openClassDate,
        rewardEndMonth: row.rewardEndMonth
      }
      if (grantStatus !== undefined && grantStatus !== null) {
        payload.grantStatus = grantStatus
      }
      return payload
    },
    updateGrantStatus (row, grantStatus) {
      if (!row || row.grantStatus === grantStatus) {
        return
      }
      this.$http.post('/referrer/fee/grantStatus', this.buildFeePayload(row, grantStatus)).then(res => {
        this.$Message.success('发放状态已更新')
        this.loadList()
      }).catch(() => {
        this.loadList()
      })
    },
    handleExport () {
      this.$http.get('/referrer/fee/export', {
        responseType: 'arraybuffer',
        params: this.buildQueryParam()
      }).then(response => {
        if (response.data) {
          let blob = new Blob([response.data], { type: 'text/csv' })
          let link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          link.download = '被推荐人管理.csv'
          link.click()
        }
      })
    },
    handleBatchGrant () {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$Message.warning('请先勾选要发放的记录')
        return
      }
      this.$Modal.confirm({
        title: '确认发放',
        content: `确定要发放选中的 ${this.selectedRows.length} 条记录吗？`,
        loading: true,
        onOk: () => {
          let payload = this.selectedRows.map(row => this.buildFeePayload(row))
          this.$http.post('/referrer/fee/grant', payload, {
            headers: { 'Content-Type': 'application/json;charset=utf-8' }
          }).then(res => {
            this.$Message.success('发放成功')
            this.selectedRows = []
            this.loadList()
          }).finally(() => {
            this.$Modal.remove()
          })
        }
      })
    }
  }
}
</script>

<style lang="less">
.fee-name-poptip {
  display: block;
  width: 100%;
  max-width: 100%;
  cursor: pointer;
}
.fee-name-poptip .ivu-poptip-rel {
  display: block;
  width: 100%;
  max-width: 100%;
}
.fee-name-cell {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

<style lang="less" scoped>
.btn-container {
  margin-bottom: 16px;
  .ivu-btn {
    margin-right: 8px;
  }
}
.search-compact {
  /deep/ .ivu-form-item {
    margin-bottom: 12px;
  }
  /deep/ .ivu-date-picker {
    width: 100%;
  }
}
.fee-summary {
  margin-top: 10px;
  padding: 8px 12px;
  background: #fafafa;
  border: 1px solid #e8eaec;
  border-radius: 4px;
  text-align: right;
  color: #515a6e;
}
.grant-status-select {
  width: 88px;
}
</style>



// WEBPACK FOOTER //
// ReferrerFeeList.vue?1da6be2b